import React from 'react';
import styles from './StepProgress.module.scss';

interface StepProgressProps {
  currentStep: number;
  totalSteps: number;
}

export default function StepProgress({ currentStep, totalSteps }: StepProgressProps) {
  return (
    <div className={styles.progress}>
      <div className={styles.dots}>
        {Array.from({ length: totalSteps }, (_, i) => {
          const step = i + 1;
          let stateClass = '';
          if (step < currentStep) stateClass = styles.complete;
          else if (step === currentStep) stateClass = styles.active;
          return <div key={step} className={`${styles.dot} ${stateClass}`} />;
        })}
      </div>
      <div className={styles.label}>
        Step {currentStep} of {totalSteps}
      </div>
    </div>
  );
}
